import styled from "styled-components";
import { fonts } from "src/constants";

export default styled.div`
    font-size: ${fonts.subtitle}px;
    line-height: 17px;
`;
